import { BaseResponse } from "../models/BaseResponse";
import { PayslipDocumentGetRequest } from "../models/PayslipDocumentGetRequest";
import { PayslipDocumentGetResponse } from "../models/PayslipDocumentGetResponse";
import { PayslipGetRequest } from "../models/PayslipGetRequest";
import { PayslipGetResponse } from "../models/PayslipGetResponse";
import { APIService } from "./APIService";


export class PayslipsAPIService {
    private _apiService: APIService;

    constructor(){
        this._apiService = new APIService();
    }

    public async getPayslips(request: PayslipGetRequest, token: string | null):Promise<BaseResponse<PayslipGetResponse>>{
        return this._apiService.sendRequest<BaseResponse<PayslipGetResponse>, PayslipGetRequest>("Payslips/GetPayslips", "POST", request, token);
    }

    public async getPayslipDocument(request: PayslipDocumentGetRequest, token: string | null):Promise<BaseResponse<PayslipDocumentGetResponse>>{
        return this._apiService.sendRequest<BaseResponse<PayslipDocumentGetResponse>, PayslipDocumentGetRequest>("Payslips/GetPayslipDocument", "POST", request, token);
    }

    public async getUserName():Promise<BaseResponse<string>>{
        return this._apiService.sendRequest<BaseResponse<string>,undefined>("Payslips/GetUserEmail","GET")
    }

}